import type { FaqItem } from '../types/content';

export const faqItems: FaqItem[] = [
  {
    question: '¿QUÉ RECIBO EXACTAMENTE?',
    answer: [
      'La oferta base incluye los 5 tomos de Maestro en Pista y los 5 bonos prácticos indicados en esta página.',
      'El Kit de Ejecución añade El Mapa de Pista y el Programador 12 Meses.'
    ]
  },
  {
    question: '¿LOS EJERCICIOS SIRVEN PARA DIFERENTES NIVELES?',
    answer: [
      'Sí. El sistema incluye herramientas para adaptar ejercicios y sesiones a distintos niveles, incluyendo grupos mixtos.'
    ]
  },
  {
    question: '¿PUEDO CONSULTAR EL MATERIAL DESDE EL MÓVIL MIENTRAS ESTOY EN LA PISTA?',
    answer: [
      'Sí. Puedes consultar el material digital desde dispositivos compatibles como móvil, tablet u ordenador, incluso justo antes de una sesión.'
    ]
  },
  {
    question: '¿ME SIRVE SI ESTOY EMPEZANDO COMO MONITOR?',
    answer: [
      'Sí. La estructura está diseñada para organizar conceptos técnicos, tácticos y metodológicos de manera progresiva.'
    ]
  },
  {
    question: '¿ES SOLO PARA MONITORES O TAMBIÉN SIRVE PARA DIRECTORES DE ESCUELA?',
    answer: [
      'Sirve para ambos. Además de monitores, directores de escuela y equipos pueden utilizar la metodología como base organizativa común.'
    ]
  },
  {
    question: '¿ES UN CURSO EN VÍDEO?',
    answer: ['No. Es un sistema digital de consulta y ejecución.']
  },
  {
    question: '¿CÓMO RECIBO EL CONTENIDO DESPUÉS DE COMPRAR?',
    answer: [
      'Tras completar la compra recibes acceso inmediato al contenido digital para consultarlo desde tu móvil, tablet u ordenador.'
    ]
  },
  {
    question: '¿ES UN ÚNICO PAGO O UNA SUSCRIPCIÓN?',
    answer: ['Es un pago único. No hay suscripciones ni cobros recurrentes.']
  },
  {
    question: '¿CUÁL ES LA DIFERENCIA ENTRE LAS DOS VERSIONES?',
    answer: [
      'La versión de 17,90 € incluye los 5 tomos y los 5 bonos.',
      'La versión de 23,90 € añade El Mapa de Pista con 50 esquemas técnicos y el Programador 12 Meses.'
    ]
  },
  {
    question: '¿CUÁNDO VOY A NOTAR RESULTADOS EN MIS CLASES?',
    answer: [
      'La mayoría de monitores nota la diferencia en la primera semana de uso. El Planificador 30 Días está diseñado para que los cambios sean progresivos y sostenibles, sin intentar aplicar todo a la vez.'
    ]
  },
  {
    question: '¿QUÉ PASA EXACTAMENTE SI PIDO LA DEVOLUCIÓN?',
    answer: [
      'Escríbenos a manualeslistos@gmail.com dentro de los 14 días desde la compra. Te devolvemos el 100% del importe en menos de 24 horas. Sin formularios, sin preguntas, sin explicaciones necesarias.'
    ]
  }
];
